var map = {
	"./allowances_controller.js": 8287,
	"./calculate_fields_controller.js": 8590,
	"./custom_payroll_form_controller.js": 7638,
	"./invoice_form_controller.js": 6004,
	"./leave_request_form_controller.js": 7570,
	"./logged_hours_controller.js": 2915,
	"./manual_time_entry_form_controller.js": 9466,
	"./modal_controller.js": 6897,
	"./nested_form_controller.js": 204,
	"./pay_slips_form_controller.js": 3893,
	"./payslip_batch_filter_controller.js": 320,
	"./reports_controller.js": 3927,
	"./search_form_controller.js": 9103,
	"./timezone_controller.js": 2559,
	"./user_roles_controller.js": 8197,
	"controllers/allowances_controller.js": 8287,
	"controllers/calculate_fields_controller.js": 8590,
	"controllers/custom_payroll_form_controller.js": 7638,
	"controllers/invoice_form_controller.js": 6004,
	"controllers/leave_request_form_controller.js": 7570,
	"controllers/logged_hours_controller.js": 2915,
	"controllers/manual_time_entry_form_controller.js": 9466,
	"controllers/modal_controller.js": 6897,
	"controllers/nested_form_controller.js": 204,
	"controllers/pay_slips_form_controller.js": 3893,
	"controllers/payslip_batch_filter_controller.js": 320,
	"controllers/reports_controller.js": 3927,
	"controllers/search_form_controller.js": 9103,
	"controllers/timezone_controller.js": 2559,
	"controllers/user_roles_controller.js": 8197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5124;